import styled, { css } from 'styled-components';
import { ITabStyled } from './Tabs.types';

export const Bullet = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: ${({ theme }) => theme.spacing.km6};
  height: ${({ theme }) => theme.spacing.km6};
  padding: 0 ${({ theme }) => theme.spacing.km2};
  background-color: ${({ theme }) => theme.color.background.neutral.weak};
  border-radius: ${({ theme }) => theme.border.radius.pill};
`;

export const Tabs = styled.ul`
  display: flex;
  gap: ${({ theme }) => theme.spacing.km4};
`;

export const Tab = styled.li<ITabStyled>`
  position: relative;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: ${({ theme }) => theme.spacing.km2};
  height: ${({ theme }) => theme.spacing.km12};
  padding: 0 10px;

  ${({ isActive }) =>
    isActive &&
    css`
      ${Bullet} {
        background-color: ${({ theme }) => theme.color.background.brand.weak};
      }

      ::before {
        content: '';
        position: absolute;
        bottom: -1px;
        width: 100%;
        height: 2px;
        border-top-left-radius: 2px;
        border-top-right-radius: 2px;
        background-color: ${({ theme }) =>
          theme.color.background.brand.default};
      }
    `}

  ${({ disabled = false }) =>
    disabled &&
    css`
      pointer-events: none;
    `}
`;
